const showWidget = () => {
  const app = document.getElementById('conferwith');
  if (app) {
    app.style.display = 'block';
  }
};

export default showWidget;
